$(function() {
  console.log("Entered cart")
    $cartRows = $('.fenix_cart');
    const $fenixResponse = $('#fenix-response')

    var $zipcode = ''

    if (Cookies.get("location") != null) {
        $zipcode = Cookies.get("location")
    }


    let ssid = ''
    if (Cookies.get('__ssid') != null) {
        ssid = document.cookie.split('; __ssid=')[1].split('; ')[0];
        console.log('ssid', ssid)
        if (!ssid) {
            ssid = '';
        }

    }

    var defaultZip = ''
    if (Cookies.get("location") != null) {
        defaultZip = Cookies.get("location")
    }

    function getZipcode(zipcode) {
        return zipcode != 0 || defaultZip
    }

    if (defaultZip) {
        checkShippingEstimate();
    }

    var flag=false
  
    function checkShippingEstimate() {

        $cartRows.each((i, el) => {
          console.log("Entered")
            var {
                zipcode,
                price,
                sku,
                page,
                availableQty,
                locationid,
                orderQty,
                available,
                weight
            } = el.dataset
            var callFennix = false

                if (availableQty >= 1) {
                    callFennix = true
                } 
         
            if (callFennix) {
                function getRequestData() {
                    return {
                        "sessionTrackId": ssid,
                        "buyerZipCode": "" + $zipcode,
                        "monetaryValue": (parseInt(price) / 100).toFixed(2),
                        "pageType": 'cart',
                        "responseFormat": "json",
                        "skus": [{
                            "quantity": 1,
                            "sku": sku,
                          "weight": { 
                		"units": "LB", 
                		"value": weight || 1
              			},
                          "dimensions":
              		{ 		
              		 "girth":"2", 
             		 "height":"2", 
              		 "length":"2", 
             		 "units": "IN", 
                      "width": "2"
            		
              		},
                            "skuInventories": [{
                                "locationId": "manual",
                                "quantity": parseInt(availableQty),
                            }]
                        }]
                    }
                }

                $.ajax({
                        type: "POST",
                        url: "https://delest-api.fenixcommerce.com/fenixdelest/api/v2/deliveryestimates",
                        async: "true",
                        data: JSON.stringify(getRequestData()),
                        headers: {
                            'tenantId': '0f3e7cb2c00240d8813473dc481daeb3 ',
                            'Content-Type': 'application/json'
                        },
                        dataType: "json"
                    })
                    .done(function(data) {
                        var res = data[0]
                        res = res.response
                        console.log("resHere", res)
                        var phrase = createPhraseForDeliveryEstimate(res)
                        el.innerHTML = phrase
                        //$fenixResponse.html(phrase)
                        
                    })
                    .fail(function(error) {
                        console.log('in fail', error, {
                            el
                        });
                        console.log("error2", error);
                        el.innerHTML = ""

                    });
            } else {
                console.log("qty", availableQty)
            }
        })

        
    }

    function getDataFromString(str, matchExp, start, end) {
        if (str.match(matchExp)) {
            return str.substring(str.match(matchExp).index + start, str.match(matchExp).index + end)
        }
    }

    function createPhraseForDeliveryEstimate(res) {
            // res="Order with in next 5 Hours, 10 Minutes, Get it by Fri, 20 Jul
            // 2018. Faster Shipping Options available at Checkout"

        // res="Order with in next 5 Hours, 10 Minutes, Get it by Fri, 20 Jul
        // 2018. Faster Shipping Options available at Checkout"
        // var phrase = "<span class='deliveryResponse'>Order with in next "
        var phrase = res
        phrase = "<span class='deliveryResponse'>" + phrase
        var hours = getDataFromString(res, "Hours", -3, -1)
        var mins = getDataFromString(res, "Minutes", -3, -1)
        var shippingMethod = res.shippingMethodDesc
        if (hours) {
            phrase = phrase.replace("" + hours + " Hours", "<b><span class='timeColor'>" + hours + " Hours</span></b>")
            phrase = phrase.replace("" + mins + " Minutes", "<b><span class='timeColor'>" + mins + " Minutes</span></b>")
        }
        if (phrase.match("Today")) {
            phrase = phrase.replace("Today", "<b><span class='timeColor'>Today</span></b>")
        }
        if (phrase.match("Faster")) {
            phrase = phrase.replace("Faster", "</span><br><span class='deliveryResponseCheckout'> Faster")
        }
        if (phrase.match("Choose")) {
            phrase = phrase.replace("Choose", "</span><br><span class='deliveryResponseCheckout'> Choose")
        }
        var dateString = getDataFromString(res, "Get it by ", 10, 29)
        if (dateString) {
            if (dateString.includes(".")) {
                dateString = dateString.split(".")[0]
            } else {
                dateString = dateString.split(",")[0] + "," + dateString.split(",")[1]
            }
            var afterDate = dateString
            var todayDate = new Date();
            var presentYear = todayDate.getFullYear();
          if(afterDate.match(presentYear)!=null){
            var afterDate = afterDate.substring(0, afterDate.match(presentYear).index + 4)
            phrase = phrase.replace("" + afterDate, "<b>" + afterDate + "</b>")
          }
        }
        phrase = phrase + "</span>"
        return phrase
    }

})